import React, { useEffect, useState } from "react";
import useDebounce from "../../../../hooks/useDebounce";
import {
  favouriteGroupListingApi,
  joinGroupApi,
  updateFavouriteListApi,
} from "../../../../services/groups";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  CategoriesGroupscard1,
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { GoDotFill } from "react-icons/go";
import { CiSearch } from "react-icons/ci";
import { IoMdArrowBack } from "react-icons/io";
import { toastMessage } from "../../../../utils/toastMessage";
import { updateFavoriteListHandler } from "./LikeUnlikeHeart";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";
import InfiniteScroll from "react-infinite-scroll-component";
import { Button, LoadingButton } from "../../../../Components/header/form";
import SubscriptionPlan from "../subscription/SubscriptionPlan";

const FavouriteGroup = ({ favoriteSearch }) => {
  const [favGroupList, setFavGroupList] = useState([]);
  const [favGroupId, setFavGroupId] = useState({});
  const [searchParam, setSearchParam] = useSearchParams();
  const [showShimmer, setShowShimmer] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(favoriteSearch, 300);
  const [total, setTotal] = useState(null);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [joinLoading, setJoinLoading] = useState(false);
  const [groupId, setGroupId] = useState("");
  const [subscriptionModal, setSubscriptionModal] = useState(false);

  //--------navigate-details-page------------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  // ---------subscription-handler------------
  const handleSubscriptionJoin = (id) => {
    setGroupId(id);
    setSubscriptionModal(true);
  };
  // console.log('favGroupList', favGroupList)
  // Rendering HTML Conditionally
  const renderHtml = (data) => {
    switch (data) {
      // case "ACCEPTED":
      //   return (
      //     <Button isDisabled={true} className="join_button">
      //       Accepted
      //     </Button>
      //   );
      case "REQUESTED":
        return (
          <Button isDisabled={true} className="join_button">
            Request Sent
          </Button>
        );
      default:
        return null; // Handle cases where the level doesn't match
    }
  };
  //------------join-group------------
  const joinGroupHandler = async (_id) => {
    try {
      setJoinLoading(true);
      const { data } = await joinGroupApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        setPage(1);
        setHasMore(true);
        favoriteGroupListHandler(1, true);
      }
      toastMessage(message, success ? "success" : "error", "joinHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setJoinLoading(false);
    }
  };
  // ----------update-status-handler--heart-----------
  const updateFavoriteListHandler = async (favGroupId) => {
    try {
      const { data } = await updateFavouriteListApi({
        _group: favGroupId,
      });
      const { success, message } = data;
      if (success) {
        setPage(1);
        setHasMore(true);
        favoriteGroupListHandler(1, true);
      } else {
        toastMessage(message, "error", "updateFavorite");
      }
    } catch (error) {
      console.error("Error updating settings:", error?.message);
      toastMessage("Failed to update settings. Please try again.", "errorLike");
    }
  };
  //----------favorite-listing-API-----------------
  const favoriteGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      setShowShimmer(true);
      const { data } = await favouriteGroupListingApi({
        pagination: "true",
        search: debouncedValue,
        limit: 12,
        page: page,
      });
      const { data: favGroupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setFavGroupList(favGroupList || []);
        } else {
          setFavGroupList((prev) => [...prev, ...(favGroupList || [])]);
        }
        setHasMore(favGroupList.length === 12);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    favoriteGroupListHandler(1, true);
  }, [debouncedValue]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      favoriteGroupListHandler(nextPage);
      return nextPage;
    });
  };

  return (
    <>
      <div className="CategoriesGroupsList_parent">
        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          <InfiniteScroll
            dataLength={favGroupList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<GroupCardSkeleton count={5} />}
            endMessage={
              <p style={{ textAlign: "center", margin: "25px" }}>
                <b>No more data to display</b>
              </p>
            }
            scrollableTarget="scrollableContainer"
          >
            <div className="health_hub_cards">
              {favGroupList && favGroupList.length > 0
                ? favGroupList?.map((data, ind) => (
                    <div key={data?._id + ind} className="health_hub_img">
                      <Link
                        to={`/dashboard/group/detail/${data?._group?._id}`}
                      ></Link>

                      <div
                        onClick={() => navigateDetailsPage(data?._group?._id)}
                        className="image_containerss"
                      >
                        <img src={data?._group?.coverImage} />
                        <div className="health_hub_img_text">
                          <h6>{data?._group?.name}</h6>
                          <p>
                            {data?._group?.newFeeds?.count > 0 ? (
                              <>
                                <GoDotFill className="live_dot" />
                                {`${data?._group?.newFeeds?.count} New Post${
                                  data?._group?.newFeeds?.count > 1 ? "s" : ""
                                }`}
                              </>
                            ) : null}
                          </p>
                        </div>
                      </div>

                      <div className="health_hub_containt">
                        <div className="rgt_tan_wrap">
                          <span>{data?._group?.categoryName}</span>
                          {data?.request &&
                          Object.keys(data?.request).length > 0 ? (
                            renderHtml(data?.request?.status)
                          ) : data?._group?.type === "SUBSCRIPTION" &&
                            data?._group?.subscription?.status !== "ACTIVE" ? (
                            <Button
                              onClick={() =>
                                handleSubscriptionJoin(data?._group?._id)
                              }
                              type="button"
                              className="share_icon"
                            >
                              Subscribe
                            </Button>
                          ) : (
                            <LoadingButton
                              loading={joinLoading}
                              className="join_button"
                              onClick={(e) => {
                                setGroupId(data?._id);
                                joinGroupHandler(data?._id);
                                e.preventDefault();
                              }}
                            >
                              Join
                            </LoadingButton>
                          )}
                        </div>
                        <figure className="health_hub_icons">
                          {data?._group?.type === "SUBSCRIPTION" && (
                            <img src={subscription_icon} className="lockimg" />
                          )}
                          {data?._group?.type === "PRIVATE" && (
                            <img src={lock_icon} className="lockimg" />
                          )}
                          {data?.status === "ACTIVE" && (
                            <img
                              src={fill_heart}
                              className="heartimg"
                              onClick={() =>
                                updateFavoriteListHandler(data?._group?._id)
                              }
                            />
                          )}
                        </figure>
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </InfiniteScroll>
        </div>
      </div>
      {/* //--------subscription-modal---------------- */}
      <SubscriptionPlan
        show={subscriptionModal}
        close={() => setSubscriptionModal(false)}
        id={groupId}
        listing={favoriteGroupListHandler}
        //-------more-data------------
        setPage={setPage}
        setHasMore={setHasMore}
        type="list"
      />
    </>
  );
};

export default FavouriteGroup;
